import { render, staticRenderFns } from "./orderInfo.vue?vue&type=template&id=21911622&scoped=true&"
import script from "./orderInfo.vue?vue&type=script&lang=js&"
export * from "./orderInfo.vue?vue&type=script&lang=js&"
import style0 from "./orderInfo.vue?vue&type=style&index=0&lang=css&"
import style1 from "./orderInfo.vue?vue&type=style&index=1&id=21911622&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21911622",
  null
  
)

export default component.exports